var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advertisement"},[_c('div',{staticClass:"advertisement-header"},[_c('div',{staticClass:"advertisement-header-text"},[_c('div',{on:{"click":_vm.handleClick}},[_vm._v("发布信息")])])]),_c('common',{attrs:{"type":"2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }